import React from "react";
import { motion } from "framer-motion";
import { X, Check } from "lucide-react";

const AVANT = [
  "Tu doutes",
  "Tu repousses",
  "Tu te compares",
  "Tu attends d'être prêt",
  "Tu minimises ta valeur",
];

const APRES = [
  "Tu ressens ta légitimité",
  "Tu poses un acte",
  "Tu t'exprimes librement",
  "Tu arrêtes de te négocier",
  "Tu reprends ta place",
];

export default function BeforeAfter() {
  return (
    <section
      data-testid="before-after-section"
      id="transformation"
      className="relative py-24 md:py-36 px-6 md:px-10 bg-obsidian-surface/40"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16 md:mb-20">
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            02 · Le glissement
          </p>
          <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
            Avant.{" "}
            <span className="font-serif italic font-light text-gold normal-case lowercase">
              après.
            </span>
          </h2>
          <p className="mt-6 font-serif italic text-lg md:text-xl text-ink-400 max-w-xl lowercase">
            la même personne. un autre point d'appui intérieur.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/5 rounded-3xl overflow-hidden border border-white/[0.06]">
          {/* AVANT */}
          <motion.div
            data-testid="avant-column"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="bg-obsidian p-10 md:p-14"
          >
            <div className="flex items-center gap-4 mb-10">
              <span className="font-display uppercase text-xs tracking-[0.3em] text-ink-400">
                Avant
              </span>
              <span className="h-px flex-1 bg-white/10" />
            </div>
            <ul className="space-y-6">
              {AVANT.map((line) => (
                <li
                  key={line}
                  className="flex items-start gap-4 text-2xl md:text-3xl font-display tracking-tight text-ink-400/80"
                >
                  <X className="w-5 h-5 shrink-0 mt-2 text-ink-400/60" />
                  <span>{line}.</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* APRÈS */}
          <motion.div
            data-testid="apres-column"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="bg-obsidian-elevated p-10 md:p-14 relative"
          >
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-br from-gold/[0.08] via-transparent to-transparent" />
            <div className="relative">
              <div className="flex items-center gap-4 mb-10">
                <span className="font-display uppercase text-xs tracking-[0.3em] text-gold">
                  Après
                </span>
                <span className="h-px flex-1 bg-gold/30" />
              </div>
              <ul className="space-y-6">
                {APRES.map((line, i) => (
                  <motion.li
                    key={line}
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.3 + i * 0.08 }}
                    className="flex items-start gap-4 text-2xl md:text-3xl font-display tracking-tight text-ink-50"
                  >
                    <Check className="w-5 h-5 shrink-0 mt-2 text-gold" />
                    <span>{line}.</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
